import { FormControl, FormControlError, FormGroup, FormLabel } from '@hai/ui-react';
import { useField } from 'formik';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { constant } from 'src/js/constant';
import { isNilOrEmpty } from 'src/js/util/global-util';

interface Props {
  name: string;
  title?: string;
  minimumDate?: any;
  maximumDate?: any;
  onChanged?: (changed: boolean) => void;
}

export const FormikDatetimePicker: React.FunctionComponent<Props> = ({
  name,
  title,
  minimumDate,
  maximumDate,
  onChanged,
  ...rest
}) => {
  const { t } = useTranslation();
  const [, meta, helper] = useField(name);
  const hasErrors = meta.error && meta.touched;
  const valueMoment = meta.value || moment();
  const serverTimeText = valueMoment?.format(constant.momentFormat.dateTime);
  // recreate date in local browser time, since our DatePicker only supports that.
  const localTimeReinterpreted = moment(serverTimeText, constant.momentFormat.dateTime); // This removes the timezone from the passed date.

  return (
    <>
      <FormGroup {...rest}>
        {!isNilOrEmpty(title) && <FormLabel>{title}</FormLabel>}
        <FormControl
          name={name}
          invalid={hasErrors}
          datetime={{
            dateFormat: constant.momentFormat.dateTime,
            initialDate: localTimeReinterpreted,
            format24Hour: moment().format('LT').length <= 5,
            minimumDate: minimumDate,
            maximumDate: maximumDate,
            localeInfo: {
              amLabel: t('date.picker.amLabel'),
              applyLabel: t('date.picker.applyLabel'),
              backLabel: t('date.picker.backLabel'),
              cancelLabel: t('date.picker.cancelLabel'),
              confirmLabel: t('date.picker.confirmLabel'),
              hhPlaceholder: t('date.picker.hhPlaceholder'),
              hoursLabel: t('date.picker.hoursLabel'),
              locale: navigator.language,
              mmPlaceholder: t('date.picker.mmPlaceholder'),
              monthLabel: t('date.picker.monthLabel'),
              pmLabel: t('date.picker.pmLabel'),
              yearLabel: t('date.picker.yearLabel'),
            },
          }}
          as="select"
          onChange={(date: any) => {
            helper.setTouched(true);
            helper.setValue(moment(date));
            onChanged?.(true);
          }}
        />
        <FormControlError show={hasErrors} mssg={meta.error} />
      </FormGroup>
    </>
  );
};
